export default __webpack_public_path__ + "static/media/upArrow.1a2fada0.svg";